import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { MapPin, Gift, Search, ArrowRight, ShoppingBag, Repeat } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const img = (u) => (u ? (u.startsWith('http') ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`) : null);

// Swap & Sell home carousel — recently listed produce, veg & seed from the Vege
// Exchange. A card taps through to that listing; "View all" opens the full exchange.
export function HomeSwapCarousel({ onOpenListing, onViewAll }) {
  const [listings, setListings] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios.get(`${API}/marketplace/listings?scope=region`, { withCredentials: true })
      .then((r) => setListings((r.data?.listings || []).filter((l) => l.status === 'active').slice(0, 12)))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  if (loaded && listings.length === 0) {
    return (
      <button onClick={onViewAll} data-testid="home-swap-empty" className="hg-press w-full flex items-center gap-2 bg-[#F4EEDE] border border-[#1A4331]/10 rounded-2xl px-4 py-4 text-left text-sm text-[#1A4331]">
        <Repeat className="w-4 h-4 text-[#6B9F4A]" /> No swaps nearby yet — tap to list produce, veg or seed
      </button>
    );
  }

  return (
    <div className="flex gap-3 overflow-x-auto pb-2" data-testid="home-swap-scroller" style={{ scrollbarWidth: 'none' }}>
      {listings.map((l) => {
        const isOffer = l.type === 'offer';
        const photo = img(l.photo_urls?.[0] || l.photo_url);
        return (
          <button key={l.id} onClick={() => onOpenListing(l.id)} data-testid={`home-swap-card-${l.id}`}
            className="hg-press flex-shrink-0 w-44 rounded-2xl overflow-hidden border border-[#1A4331]/10 bg-[#FAF6EC] text-left">
            <div className="relative h-28 bg-[#6B9F4A]/12">
              {photo ? <img src={photo} alt={l.title} loading="lazy" className="w-full h-full object-cover" />
                : <div className="w-full h-full flex items-center justify-center"><ShoppingBag className="w-6 h-6 text-[#6B9F4A]" /></div>}
              <span className={`absolute top-2 left-2 inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded-full text-[#FAF6EC] ${isOffer ? 'bg-[#6B9F4A]' : 'bg-[#C9A85B]'}`}>
                {isOffer ? <Gift className="w-2.5 h-2.5" /> : <Search className="w-2.5 h-2.5" />} {isOffer ? 'Offering' : 'Wanted'}
              </span>
            </div>
            <div className="p-2.5">
              <p className="font-semibold text-sm text-[#1A4331] truncate">{l.title}{l.variety ? ` · ${l.variety}` : ''}</p>
              <p className="text-[11px] text-[#7A6B57] truncate flex items-center gap-1 mt-0.5"><MapPin className="w-3 h-3" />{l.region_label || l.location || 'Nearby'}</p>
            </div>
          </button>
        );
      })}
      <button onClick={onViewAll} data-testid="home-swap-viewall" className="hg-press flex-shrink-0 w-24 flex flex-col items-center justify-center gap-2 text-[#1A4331]">
        <span className="w-12 h-12 rounded-full bg-[#6B9F4A]/14 border border-[#6B9F4A]/30 flex items-center justify-center"><ArrowRight className="w-5 h-5" /></span>
        <span className="text-xs font-semibold">View all</span>
      </button>
    </div>
  );
}
